import StatSquare from './StatSquare';
export default StatSquare;
